/** Checksum FNV-1a do estado — comparação cliente×servidor (A2: divergiu → resync). */
import type { RunState } from './types.ts';

function fnv1a(h: number, v: number): number {
  h = (h ^ (v & 0xff)) >>> 0;
  h = Math.imul(h, 0x01000193) >>> 0;
  h = (h ^ ((v >>> 8) & 0xff)) >>> 0;
  h = Math.imul(h, 0x01000193) >>> 0;
  h = (h ^ ((v >>> 16) & 0xff)) >>> 0;
  h = Math.imul(h, 0x01000193) >>> 0;
  h = (h ^ ((v >>> 24) & 0xff)) >>> 0;
  h = Math.imul(h, 0x01000193) >>> 0;
  return h;
}

/** quantiza posição a 1/8 px — elimina ruído de float na comparação */
const q = (n: number): number => Math.round(n * 8) | 0;

export function checksumRun(s: RunState): number {
  let h = 0x811c9dc5;
  h = fnv1a(h, s.tick);
  h = fnv1a(h, s.stats.kills);
  h = fnv1a(h, s.stats.luar);
  for (const hero of s.heroes) {
    h = fnv1a(h, q(hero.x));
    h = fnv1a(h, q(hero.y));
    h = fnv1a(h, Math.round(hero.hp * 16));
    h = fnv1a(h, hero.xp);
  }
  for (const e of s.enemies) {
    if (!e.alive) continue;
    h = fnv1a(h, q(e.x));
    h = fnv1a(h, q(e.y));
    h = fnv1a(h, Math.round(e.hp * 16));
  }
  return h >>> 0;
}
